import { render, staticRenderFns } from "./troop.vue?vue&type=template&id=4193a5ab&"
import script from "./troop.vue?vue&type=script&lang=js&"
export * from "./troop.vue?vue&type=script&lang=js&"
import style0 from "./troop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports